import { render, staticRenderFns } from "./RatePlanListTable.vue?vue&type=template&id=521b124f&scoped=true&"
import script from "./RatePlanListTable.vue?vue&type=script&lang=js&"
export * from "./RatePlanListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521b124f",
  null
  
)

export default component.exports